<template lang="pug">
.history
    template(v-if="draws")
      .withdrawal__content
        .withdrawal-table
          .withdrawal-table__title
            .withdrawal-table__th.at-col-1 Номер заявки
            .withdrawal-table__th.at-col-2 Дата добавления
            .withdrawal-table__th.at-col-3 Сумма
            .withdrawal-table__th.at-col-4 Статус

          .withdrawal-table__content
            template(v-if="windowWidth > 992")
              .withdrawal-table__item.item-draw(
                v-for='draw in draws'
                :key="draw.id"
              )
                .item-draw__item.at-col-1
                  .item-draw__number {{ draw.id }}
                .item-draw__item.at-col-2 {{ draw.date }}
                .item-draw__item.at-col-3
                  .item-draw__balance {{ onFormat(draw.summ) }} Р
                .item-draw__item.at-col-4
                  .item-draw__status
                    u(:class='draw.status') {{ draw.statusText }}
                    | {{ draw.paidDate }}
              .withdrawal-table__item.item-draw.item-draw--total
                .item-draw__item.at-col-1
                  .item-draw__total Итого успешно выплачено:
                .item-draw__item.at-col-3
                  .item-draw__balance {{ onFormat(18257.83) }} Р
                .item-draw__item.at-col-4
            template(v-else)
              .withdrawal-table__item.item-draw(
                v-for='draw in draws'
                :key="draw.id"
              )
                .item-draw__item.at-col-1
                  .item-draw__number
                    span Номер заявки
                    |{{ draw.id }}
                .item-draw__item.at-col-2
                  span Дата добавления
                  |{{ draw.date }}
                .item-draw__item.at-col-3
                  .item-draw__balance
                    span Сумма
                    |{{ onFormat(draw.summ) }} Р
                .item-draw__item.at-col-4
                  .item-draw__status
                    span Статус
                    u(:class='draw.status') {{ draw.statusText }}
                    | {{ draw.paidDate }}

    .history__text(v-else) Выплат ещё не было
</template>

<style lang='scss' scoped>
.withdrawal-table__th,
.item-draw__item{
  padding-right: 10px;
}
.at-col-1{
  width: 250px;
  flex-grow: 0;
}
.at-col-2{
  width: 450px;
  margin-right: auto;
}
.at-col-3{
  width: 250px;
}
.at-col-4{
  width: 170px;
  flex-shrink: 0;
}
.tabs{
  padding: 0;
  &__title{
    margin-bottom: 20px;
  }
}
@media (max-width: 991px) {
  .item-draw__item.at-col-2 {
    width: calc(100% - 450px);
  }
}
@media (max-width: 767px)  {
  .item-draw__item.at-col-1{
    width: 100%;
  }
  .item-draw__item.at-col-2{
    order: 0;
    width: auto;
  }
  .item-draw__item.at-col-3{
    width: auto;
  }
  .tabs__title{
    flex-direction: column;
    width: 100%;
  }
}
.history{
    &__text{
        color: #161616;
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 30px;
    }
}
@media (max-width: 768px)  {
  .history{
    &__text{
      font-size: 15px;
    }
  }
}
</style>

<script>
export default {
  name: 'History-Tab',
  props: ['draws'],
  data: function() {
    return {
      windowWidth: null,

    }
  },
  mounted() {
    this.$nextTick(function() {
      window.addEventListener('resize', this.resize);
      this.resize()
    })
  },
  computed: {
  },
  methods: {
    onFormat(number) {
      return parseFloat(number).toLocaleString('ru-RU')
    },
    resize() {
      this.windowWidth = document.documentElement.clientWidth;
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
  }
}
</script>